"use strict";

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _classCallCheck = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/createClass");

require("core-js/modules/es6.object.define-property");

var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function (receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};

var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function (receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};

var _ErrorService_baseSampleRate, _ErrorService_root;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorService = exports.SeverityLevel = void 0;

var getBaseSampleRate_1 = require("./getBaseSampleRate");

var feature_1 = require("../log/feature");
/** The severity level of an error */


var SeverityLevel;

(function (SeverityLevel) {
  SeverityLevel[SeverityLevel["Debug"] = 0] = "Debug";
  SeverityLevel[SeverityLevel["Warning"] = 1] = "Warning";
  SeverityLevel[SeverityLevel["Error"] = 2] = "Error";
})(SeverityLevel || (exports.SeverityLevel = SeverityLevel = {}));
/**
 * A service for managing error reporting.
 *
 * @remarks
 * Usually a feature like the Sentry feature uses this to consume errors. You can use this
 * service to report errors from your feature, and to report when the current user is changing.
 *
 * You may also use it to leave breadcrumbs, which are little bits of information that make their
 * way to the error reporting service you're using whenever an error occurs.
 */


var ErrorService = /*#__PURE__*/function () {
  function ErrorService(root) {
    _classCallCheck(this, ErrorService);

    _ErrorService_baseSampleRate.set(this, (0, getBaseSampleRate_1.getBaseSampleRate)());

    _ErrorService_root.set(this, void 0);

    __classPrivateFieldSet(this, _ErrorService_root, root, "f");
  }

  _createClass(ErrorService, [{
    key: "setBaseSampleRate",
    value: function setBaseSampleRate(baseSampleRate) {
      __classPrivateFieldSet(this, _ErrorService_baseSampleRate, baseSampleRate, "f");
    }
    /**
     * Sets the user context to send with errors to the error service.
     * @param user - the user context
     */

  }, {
    key: "setUserContext",
    value: function setUserContext(user) {
      this._setUserContext(user);

      var transaction = this.getCurrentTransaction();

      if (transaction) {
        (0, feature_1.debug)('updating user context in transaction and updating sample');
        transaction.setContext('user', user);
        transaction.sampled = this.shouldSample(transaction);
      }
    }
    /** Starts a new transaction. */

  }, {
    key: "startTransaction",
    value: function startTransaction(opts) {
      return this._startTransaction(Object.assign({
        sampled: this.shouldSample(opts)
      }, opts));
    }
  }, {
    key: "withTransaction",
    value: function withTransaction(opts, callback) {
      var transaction = this.startTransaction(opts);

      try {
        return callback(transaction);
      } finally {
        if (transaction) {
          transaction.finish();
        }
      }
    }
  }, {
    key: "shouldSample",
    value: function shouldSample(transaction) {
      var _a, _b;

      if (!__classPrivateFieldGet(this, _ErrorService_root, "f")) return false;
      var anyTransaction = transaction;

      var sampleRate = __classPrivateFieldGet(this, _ErrorService_root, "f").deps.hookManager.mutateHookSync('transaction-sample-rate', __classPrivateFieldGet(this, _ErrorService_baseSampleRate, "f"), {
        transaction: transaction,
        userGroup: (_b = (_a = anyTransaction._contexts) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.group
      });

      if (!transaction.data) transaction.data = {};
      transaction.data.sampleRate = sampleRate;
      var shouldSample = Math.random() < sampleRate;
      (0, feature_1.debug)('shouldSample: %O (modified rate %O)', shouldSample, sampleRate);
      return shouldSample;
    }
  }], [{
    key: "adjustSampleRate",
    value: function adjustSampleRate(sampleRate, group, groupRatios) {
      if (!(group in groupRatios) || Object.keys(groupRatios).length < 2) return sampleRate;
      var numGroups = Object.keys(groupRatios).length; // totalValuesExcluding would be 102 for teachers, 101 for admins, and 3 for students.

      var totalValuesExcluding = Object.keys(groupRatios).filter(function (k) {
        return k !== group;
      }).reduce(function (a, b) {
        return a + groupRatios[b];
      }, 0); // inverseContribution would be 102 for teachers, 50.5 for admins, and 0.03 for students.

      var inverseContribution = totalValuesExcluding / groupRatios[group];
      var result = sampleRate * inverseContribution / (numGroups - 1);
      result = Math.max(0, Math.min(1, result));
      (0, feature_1.debug)('adjusted sample rate for group %s: %O (original %O)', group, result, sampleRate);
      return result;
    }
  }]);

  return ErrorService;
}();

exports.ErrorService = ErrorService;
_ErrorService_baseSampleRate = new WeakMap(), _ErrorService_root = new WeakMap();